<template>
    <div>
        <div v-if="erro">
            <SemPermissao></SemPermissao>
        </div>
        <template v-if="!erro">
            <OcorrenciaForm :ocorrencia="null" />
        </template>
    </div>
</template>

<script>
    import OcorrenciaForm from '../../components/ocorrencias/OcorrenciaForm.vue';
    import SemPermissao from "../SemPermissao.vue"
    
    //import ErroResultados from "../../components/ErroResultados";

    export default {
        name: "OcorrenciasNew",
        data() {
            return {
                erro: false,
            };
        },
        components: {
            SemPermissao,
            //ErroResultados,
            OcorrenciaForm,
        },
    };
</script>

<style lang="scss" scoped>
</style>